exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-inner>.item>a>img, .carousel-inner>.item>img, .img-responsive, .thumbnail a>img, .thumbnail>img {\r\n    display: block;\r\n    max-width: 100%;\r\n    height: auto;\r\n    width: 100%;\r\n}\r\n\r\n.carousel-control.right i,\r\n.carousel-control.left i{\r\n    position: relative;\r\n    top:50%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/src/app/widgets/slideshow/slideshow.component.css
// module id = ../../../../../src/app/widgets/slideshow/slideshow.component.css
// module chunks = main